import React, { useEffect, useState } from 'react'
import ValueOne from '../../Assetes/Images/value-1.png'
import ValueTwo from '../../Assetes/Images/value-2.png'
import ValueThree from '../../Assetes/Images/value-3.png'
import ValueFour from '../../Assetes/Images/value-4.png'
import ValueFive from '../../Assetes/Images/value-5.png'
import ValueSix from '../../Assetes/Images/value-6.png'
import CareersInputs from './CareersInputs'
import Footer from '../../Components/Footer'
import Header from '../../Components/Header'
import useTheme from '../../MobileAppUrl/UseTheme'
import useDarkTheme from '../../MobileAppUrl/UseDarkTheme'
import { IMAGE_URL } from '../../Components/client-config'
import { CAREER_GRID_ONE, CAREER_GRID_TWO, CAREER_GRID_THREE, CAREER_GRID_FOUR, CAREER_GRID_FIVE, CAREER_GRID_SIX } from './../../constants'

export default function CareersPage(props: any) {

  const { theme, toggleTheme } = useTheme();
  const { darktheme, toggleDarkTheme } = useDarkTheme();


  useEffect(() => {
    const { theme } = props.match.params;

    if (theme === undefined) {
      localStorage.removeItem("theme");
    } else if (theme === "night") {
      toggleDarkTheme();
    } else if (theme === "day") {
      toggleTheme();
    }
  }, [props.match.params]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <> <Header />
      <div className='about-us'>
        <div className="container">
          <video width="100%" controls>
            <source src={`${IMAGE_URL}kfc_video.mp4`} type="video/mp4" />
          </video>
        </div>
        <div className="our-values pb-5">
          <div className="container">
            <h2 className='our-title mt-100'>Our Values</h2>
            <div className="row">
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueOne} alt="ValueOne" />
                  <h5>Believe in All People</h5>
                  <p>{CAREER_GRID_ONE}</p>
                </div>
              </div>
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueTwo} alt="ValueOne" />
                  <h5>Recognize</h5>
                  <p>{CAREER_GRID_TWO}</p>
                </div>
              </div>
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueThree} alt="ValueOne" />
                  <h5>Run Great Restaurants</h5>
                  <p>{CAREER_GRID_THREE}</p>
                </div>
              </div>
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueFour} alt="ValueOne" />
                  <h5>Go for Breakthrough</h5>
                  <p>{CAREER_GRID_FOUR}</p>
                </div>
              </div>
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueFive} alt="ValueOne" />
                  <h5>Build Know How</h5>
                  <p>{CAREER_GRID_FIVE}</p>
                </div>
              </div>
              <div className="col-md-4 mt-5">
                <div className="value-overview">
                  <img className='w-100' src={ValueSix} alt="ValueOne" />
                  <h5>Work as a Team</h5>
                  <p>{CAREER_GRID_SIX}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CareersInputs />
        <Footer />
      </div>
    </>
  )
}
